import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/scanner-white.png';
import _imports_1 from '@/assets/images/icons/scanner.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-002d4b64"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "promocode-wrapper d-flex fl-col fl-j-c fl-a-c"
};
var _hoisted_2 = {
  class: "w-100 pb-10 d-flex fl-j-c fl-a-c options-wrapper"
};
var _hoisted_3 = {
  class: "inputs-wrapper"
};
var _hoisted_4 = {
  class: "d-flex fl-s-b fl-a-c"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    style: {
      "width": "40px",
      "height": "40px"
    },
    src: _imports_0,
    alt: "Scanner icon"
  }, null, -1);
});

var _hoisted_6 = {
  class: "scanner-divider"
};
var _hoisted_7 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_8 = {
  class: "input-container"
};
var _hoisted_9 = {
  class: "button-container"
};
var _hoisted_10 = {
  style: {
    "margin-top": "10px",
    "width": "96%",
    "margin-left": "auto",
    "margin-right": "auto"
  }
};
var _hoisted_11 = {
  class: "codes-container",
  style: {
    "display": "flex",
    "flex-direction": "row",
    "flex-wrap": "wrap"
  }
};
var _hoisted_12 = {
  class: "d-flex flex-row fl-j-c",
  style: {
    "height": "45px",
    "line-height": "45px",
    "background-color": "#efefef",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};
var _hoisted_13 = {
  style: {
    "text-align": "center",
    "width": "80%"
  }
};
var _hoisted_14 = ["onClick"];

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "X", -1);
});

var _hoisted_16 = [_hoisted_15];
var _hoisted_17 = {
  class: "code-results d-flex fl-col fl-j-c"
};
var _hoisted_18 = {
  style: {
    "margin-top": "5px"
  }
};
var _hoisted_19 = {
  style: {
    "margin-top": "5px"
  }
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = {
  class: "content"
};
var _hoisted_22 = {
  class: "w-100 d-flex fl-j-c fl-a-c"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    style: {
      "height": "80px",
      "margin": "0 20px"
    },
    src: _imports_1,
    alt: "Scanner icon"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "primary",
    class: _normalizeClass(["booking-button btn-option", {
      selected: _ctx.paymentType === _ctx.PaymentMethods.POS_PROMO_CODE
    }]),
    disabled: _ctx.paymentType === _ctx.PaymentMethods.POS_PROMO_CODE,
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.updatePaymentType(_ctx.PaymentMethods.POS_PROMO_CODE);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.promocode")), 1)];
    }),
    _: 1
  }, 8, ["class", "disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    class: _normalizeClass(["booking-button btn-option", {
      selected: _ctx.paymentType === _ctx.PaymentMethods.POS_GIFT_CARD
    }]),
    disabled: _ctx.paymentType === _ctx.PaymentMethods.POS_GIFT_CARD,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.updatePaymentType(_ctx.PaymentMethods.POS_GIFT_CARD);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.gift-card")), 1)];
    }),
    _: 1
  }, 8, ["class", "disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    class: _normalizeClass(["booking-button btn-option", {
      selected: _ctx.paymentType === _ctx.PaymentMethods.POS_MEMBERSHIP
    }]),
    disabled: _ctx.paymentType === _ctx.PaymentMethods.POS_MEMBERSHIP,
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.updatePaymentType(_ctx.PaymentMethods.POS_MEMBERSHIP);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.membership")), 1)];
    }),
    _: 1
  }, 8, ["class", "disabled"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    class: "el-button booking-button scan-promocode-button",
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    function () {
      return _ctx.openScanPromocodeModal && _ctx.openScanPromocodeModal.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("button.scan-voucher")), 1), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_divider)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
    "input-style": "height: 80px; font-size: 26px;",
    placeholder: _ctx.inputPlaceholder,
    modelValue: _ctx.promocode,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.promocode = $event;
    })
  }, {
    suffix: _withCtx(function () {
      return [_createVNode(_component_el_icon, {
        class: "el-input__icon",
        style: {
          "height": "80px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_SvgIcon, {
            iconContent: _ctx.editPenIconContent,
            iconAlt: _ctx.editPenIconAlt,
            iconStyle: _ctx.editPenIconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["placeholder", "modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    type: "primary",
    loading: _ctx.isLoading,
    class: "booking-button",
    "button-style": "height: 80px",
    onClick: _ctx.applyPromocode,
    disabled: !_ctx.isPromocodeLengthValid
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
    }),
    _: 1
  }, 8, ["loading", "onClick", "disabled"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedCodesStats, function (stat) {
    return _openBlock(), _createElementBlock("div", {
      key: stat.code,
      class: "one-code-container d-flex fl-col fl-j-c",
      style: {
        "width": "47%",
        "margin-bottom": "5px",
        "margin-top": "5px",
        "margin-right": "2%"
      }
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, _toDisplayString(stat.code), 1)]), _createElementVNode("div", {
      style: {
        "cursor": "pointer",
        "text-align": "center",
        "width": "15%",
        "font-size": "25px"
      },
      onClick: function onClick($event) {
        return _ctx.removeCodePayment(stat.code);
      }
    }, _hoisted_16, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("p", null, _toDisplayString(-(stat.ttlDiscountOrPayment / 100).toFixed(2) + " " + _ctx.currency), 1)]), _createElementVNode("div", _hoisted_19, [Number(stat.remaining) >= 0 ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("promocode.remaining-amount")) + " " + _toDisplayString((Number(stat.remaining) / 100).toFixed(2) + " " + _ctx.currency), 1)) : _createCommentVNode("", true)])])]);
  }), 128))])])]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.scanPromocodeModal,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return _ctx.scanPromocodeModal = $event;
    }),
    "custom-class": "scan-promocode-modal",
    width: "620px",
    "align-center": ""
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("p", null, _toDisplayString(_ctx.$t("promocode.please-scan-voucher")), 1)])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}